import { rangeArray } from "common/utils/numbers";

import styles from "../../styles/ProgressBar.module.less";

type ProgressBarProps = {
  totalSteps: number;
  stepIndex: number;
  className?: string;
};

const genStyle = (stepIndex: number, i: number) => {
  if (i === stepIndex) {
    return "active";
  }
  if (i < stepIndex) {
    return "full";
  }
  return "empty";
};

const ProgressBar = ({ totalSteps, stepIndex, className = "" }: ProgressBarProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {rangeArray(0, totalSteps).map((i) => {
        return <div key={i} className={`${styles.bar} ${styles[genStyle(stepIndex, i)]}`} />;
      })}
    </div>
  );
};

export default ProgressBar;
